import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';

interface CreateOrderForSubscriptionCancellationFnPayload {
    subscriptionId: string;
    cancellationType?: 'immediate' | 'end_of_billing_period';
    cancellationReason: string;
}

export type CreateOrderForSubscriptionCancellationFn = (
    payload: CreateOrderForSubscriptionCancellationFnPayload,
) => Promise<unknown>;

export function initCreateOrderForSubscriptionCancellationFn({
    dependencies,
}: DomainInitPayload): CreateOrderForSubscriptionCancellationFn {
    const { clientSdk } = dependencies;
    return async ({
        subscriptionId,
        cancellationType,
        cancellationReason,
    }: CreateOrderForSubscriptionCancellationFnPayload) => {
        try {
            const order = await clientSdk.commerce.order.cancelSubscription({
                subscriptionId,
                ...(cancellationType && { cancellationType }),
                cancellationReason: {
                    code: cancellationReason,
                },
            });
            // TODO: add analytics
            return order;
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
